import React from 'react';

export const IconHeartOutlined = props => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 3.0144C3.62132 3.0144 2.5 4.13747 2.5 5.52739C2.5 5.93103 2.56358 6.23927 2.69647 6.52425C2.83228 6.81546 3.05458 7.11275 3.41642 7.47458L3.42154 7.4797L7.99997 12.3313L12.5745 7.48305L12.5797 7.47792C13.0512 7.00638 13.5 6.26771 13.5 5.52739C13.5 4.13747 12.3787 3.0144 11 3.0144C9.69552 3.0144 8.81231 4.08377 8.48944 5.62962C8.44099 5.86161 8.23632 6.02771 7.99932 6.02739C7.76233 6.02707 7.55811 5.86041 7.51029 5.62829C7.18803 4.06426 6.30654 3.0144 5 3.0144ZM1.5 5.52739C1.5 3.58926 3.06497 2.0144 5 2.0144C6.44408 2.0144 7.42847 2.86749 8.00249 4.00307C8.57666 2.87526 9.55894 2.0144 11 2.0144C12.935 2.0144 14.5 3.58926 14.5 5.52739C14.5 6.63224 13.8619 7.60782 13.2921 8.17971L8.00003 13.7884L2.70411 8.17648C2.30023 7.7719 1.99287 7.38152 1.79018 6.9469C1.58372 6.50418 1.5 6.04619 1.5 5.52739Z"
        fill="currentColor"
      />
    </svg>
  );
};
